import { HTMLGenricComponent } from "./../htmlComponent/HTML-Genric-Component.JSON";
import { CellComponentDetailRequestJSON } from "./../questionPage/Cell-Component-Detail-Request.JSON";
import { ColumnLevelValidationJSON } from "./../questionPage/Column-Level-Validation.JSON";
import { ValueAddedForOptionJSON } from "./Value-Added-For-Option.JSON";

export class QuestionColumnRequestJSON {
    questionColumnID: Number;
    columnSequence: Number;
    optionTypeID: Number;
    componentTypeID: Number;
    columnTextComponentJSON: HTMLGenricComponent;
    cellComponentDetailJSONList: CellComponentDetailRequestJSON[];
    columnValidationJSONList: ColumnLevelValidationJSON[];
    valuesListForAColumnList: ValueAddedForOptionJSON[];
    columnErrorMessage: String;
    constructor() {
        this.columnTextComponentJSON = new HTMLGenricComponent;
        this.cellComponentDetailJSONList = new Array<CellComponentDetailRequestJSON>();
        this.columnValidationJSONList = new Array<ColumnLevelValidationJSON>();
        this.valuesListForAColumnList = new Array<ValueAddedForOptionJSON>();
    }
}